import React from 'react';

import PropTypes from 'prop-types';

import uuidv4 from 'uuid';

//component:
import FloatNumberFormatInput from '../../components/float_number_input_formatter';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { Tooltip, Fade } from '@material-ui/core';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
        margin: '8px 0'
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    textArea: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        width: 185,
        height: 72,
    },
    buttonsContainer: {
        marginTop: 35,
        marginLeft: 25,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 20px',
        marginBottom: 20,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    rtl: {
        textAlign: 'right',
    },
    fontSize: {
        fontSize: 13
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class EditGastosGrid extends React.Component {

    constructor(props) {
        super(props);



        //si venimos de cierre diario (existe this.producto)
        //ponemos a true la propiedad de artGastoLocked para indicar que 
        //no se puede cambiar el tipo de zona(articuloId y tipoZona ya no vienen como parametros)

        this.state = {

            id: this.props.gasto.id ? this.props.gasto.id : uuidv4(),
            tipoZona: this.props.gasto.tipoZona ? this.props.gasto.tipoZona : this.props.zonas[0].descr,
            iTipoGasto: this.props.gasto.iTipoGasto ? this.props.gasto.iTipoGasto : this.props.conceptos[0].id,
            tipoArticulo: this.props.gasto.tipoArticulo ? this.props.gasto.tipoArticulo : this.props.conceptos[0].descr,
            importe: this.props.gasto.importe ? this.props.gasto.importe : '',
            observ: this.props.gasto.observ ? this.props.gasto.observ : '',
            fecha: this.props.gasto.fecha ? this.props.gasto.fecha : this.props.fecha,
            articuloId: this.props.gasto.articuloId ? this.props.gasto.articuloId : this.props.zonas[0].id,
            artGastoLocked: this.props.producto ? true : false
        }
    }


    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    handleZonaChange = (event) => {
        this.setState({
            ...this.state,
            articuloId: event.target.value,
            tipoZona: this.props.zonas.find(tz => tz.id === parseInt(event.target.value)).descr
        });
    };

    handleConceptoChange = (event) => {
        this.setState({
            ...this.state,
            iTipoGasto: event.target.value,
            tipoArticulo: this.props.conceptos.find(tz => tz.id === parseInt(event.target.value)).descr
        });
    };

    compare = (a, b) => {
        if (a.descr < b.descr)
            return -1;
        if (a.descr > b.descr)
            return 1;
        return 0;
    }

    fillZonas = () => {
        return [...this.props.zonas].sort(this.compare).map((zona, index) => {
            return (
                <option key={zona.id} value={zona.id}>{zona.descr}</option>
            );
        });
    };

    fillConceptos = () => {
        return [...this.props.conceptos].sort(this.compare).map((concepto, index) => {
            return (
                <option key={concepto.id} value={concepto.id}>{concepto.descr}</option>
            );
        });
    };

    render() {
        const { classes } = this.props;

        //el select de tipo de zona es de solo lectura si venimos de cierre diario (this.state.artGastoLocked)
        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="zona-placeholder">
                            Zona
                            </InputLabel>

                        <Select
                            native
                            value={this.state.articuloId}
                            onChange={(event) => this.handleZonaChange(event)}
                            name="zonaId"
                            inputProps={{ readOnly: this.state.artGastoLocked }}
                        >
                            {this.fillZonas()}
                        </Select>
                    </FormControl>

                    <Tooltip title={'Artículo de gasto'} TransitionComponent={Fade} TransitionProps={{ timeout: 500 }} placement="top" classes={{ tooltip: this.props.classes.tooltip }}>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="concepto-placeholder">
                                Artículo
                        </InputLabel>
                            <Select
                                native
                                value={this.state.iTipoGasto}
                                onChange={(event) => this.handleConceptoChange(event)}
                                name="iTipoGasto"
                            >
                                {this.fillConceptos()}
                            </Select>
                        </FormControl>
                    </Tooltip>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl} style={{ marginTop: 16 }}>
                        <Tooltip title={'Importe con IVA  incluido'} TransitionComponent={Fade} TransitionProps={{ timeout: 500 }} placement="top" classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                id={'importe'}
                                label={'Importe'}
                                placeholder={'Importe'}
                                InputProps={{ classes: { input: classes.rtl }, inputComponent: FloatNumberFormatInput }}
                                margin="normal"
                                value={this.state.importe}
                                onChange={(event) => this.handleValueChange(event, 'importe')}
                            />
                        </Tooltip>
                    </FormControl>
                    <FormControl className={classes.textArea} style={{ marginTop: -24 }}>
                        <TextField
                            id={'observ'}
                            label={'Observ'}
                            placeholder={'Observ'}
                            margin="normal"
                            multiline
                            rows="2"
                            InputProps={{ classes: { input: classes.fontSize } }}
                            value={this.state.observ}
                            onChange={(event) => this.handleValueChange(event, 'observ')}
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const gasto = {
                            id: this.state.id,
                            tipoZona: this.state.tipoZona,
                            iTipoGasto: this.state.iTipoGasto,
                            tipoArticulo: this.state.tipoArticulo,
                            importe: this.state.importe,
                            observ: this.state.observ,
                            fecha: this.state.fecha,
                            articuloId: this.state.articuloId,
                            usuarioId: this.props.usuario,
                        }

                        if (this.props.checkValues(gasto)) {

                            this.props.okHandler(gasto);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>

            </div>
        );

    };


};

EditGastosGrid.propTypes = {
    gasto: PropTypes.object,
    producto: PropTypes.object.isRequired,
    zonas: PropTypes.array.isRequired,
    conceptos: PropTypes.array.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkValues: PropTypes.func.isRequired,
    usuario: PropTypes.number.isRequired,
    fecha: PropTypes.string.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditGastosGrid);